var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var BaseCalculationRequest_1;
import { JSON, JsonDiscriminatorProperty, JsonSchemaV2 } from '@symon-ai/wisepipe-serialize';
import { baseCalculationRequestSchemaValidation } from '../validations.generated';
export var CalculationType;
(function (CalculationType) {
    // Add Data
    CalculationType["STANDARD"] = "standard";
    // used by transient calc pipe for tq import
    CalculationType["TRANSIENT_PIPE"] = "transient_pipe";
    // used by transient run for icm's symon calc
    CalculationType["TRANSIENT"] = "transient";
    // used to prevent locking and building from happening at same time
    CalculationType["LOCKING"] = "locking";
})(CalculationType || (CalculationType = {}));
export const baseCalculationRequestSchema = {
    $id: 'urn:wisepipe-common-computation:BaseCalculationRequest',
    type: 'object',
    properties: {
        type: { type: 'string', enum: Object.values(CalculationType) }
    },
    required: ['type']
};
let BaseCalculationRequest = BaseCalculationRequest_1 = class BaseCalculationRequest {
    constructor(type) {
        this.type = type;
        JSON.validate(this, BaseCalculationRequest_1);
    }
};
BaseCalculationRequest = BaseCalculationRequest_1 = __decorate([
    JsonSchemaV2(baseCalculationRequestSchema, baseCalculationRequestSchemaValidation),
    JsonDiscriminatorProperty('type')
], BaseCalculationRequest);
export { BaseCalculationRequest };
//# sourceMappingURL=baseCalculationRequest.js.map